import { api } from "../api/api";
import { server_base_endpoints } from "../api/server-base-endpoints";

export interface IUpsertUserSettingPayload {
  user_settings_uuid: string | null;
  master_company_outlet_env_uuid: string | null;
  user_uuid: string | null;
  setting_value: string | null;
  status: "ACTIVE" | "INACTIVE";
}

export interface IUpsertUserSettingResponse {
  data: {
    user_settings_uuid: string;
    master_company_outlet_env_uuid: string | null;
    user_uuid: string | null;
    setting_value: string | null;
    status: string;
  };
  message: string;
}

export const upsertUserSettingAsync = async (
  payload: IUpsertUserSettingPayload,
): Promise<IUpsertUserSettingResponse> => {
  const res = await api.post(
    server_base_endpoints.siteConfiguration.upsert_user_setting,
    payload,
  );
  return res.data;
};
